import { Grid } from '@mui/material';
import { IAudienceDeletionDialogFooter } from './types';
import ActionButton from 'components/buttons/index';
import BinIcon from 'assets/icons/cabinet/bin-icon.svg';
import { styles } from './styles';

export const AudienceDeletionDialogFooter = ({
  confirmDisabled,
  isLoading,
  onCancel,
  onConfirm,
}: IAudienceDeletionDialogFooter) => {
  return (
    <Grid sx={{ marginTop: '40px' }}>
      <Grid container justifyContent="space-between" sx={styles.buttonContainer}>
        <ActionButton
          type="button"
          variant="secondary"
          label="Cancel"
          style={styles.cancelButton}
          disabled={isLoading}
          onClick={onCancel}
        />
        <ActionButton
          variant="secondary"
          startIcon={<BinIcon />}
          label="Confirm & Delete"
          style={styles.confirmAndDeleteButton}
          onClick={onConfirm}
          loading={isLoading}
          disabled={confirmDisabled}
        />
      </Grid>
      <Grid />
    </Grid>
  );
};
